/**
 * The swipe progress of the drawer gesture.
 * @type {number}
 */
export const swipeProgress = '--drawer-swipe-progress';
